import {
  DEFAULT_LOCALE,
  LOCALE,
  SUPPORT_LOCALE,
} from '@/libs/constants/locale';

export function getUserLocale() {
  return SUPPORT_LOCALE.includes(LOCALE) ? LOCALE : DEFAULT_LOCALE;
}
